export const environment = {
	production: false,
	API_GENERAL_URL: 'https://clip-api.3cubehealth.com/',
	MANTRA_FINGERPRINT_DEVICE_URL:'https://localhost:8003/mfs100/'
};